import { render, staticRenderFns } from "./jobReturnReviewDialog.vue?vue&type=template&id=133d8b28&scoped=true&"
import script from "./jobReturnReviewDialog.vue?vue&type=script&lang=js&"
export * from "./jobReturnReviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./jobReturnReviewDialog.vue?vue&type=style&index=0&id=133d8b28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133d8b28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133d8b28')) {
      api.createRecord('133d8b28', component.options)
    } else {
      api.reload('133d8b28', component.options)
    }
    module.hot.accept("./jobReturnReviewDialog.vue?vue&type=template&id=133d8b28&scoped=true&", function () {
      api.rerender('133d8b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/jobReturnReviewDialog.vue"
export default component.exports